import React, { useState } from "react";
import { Container, Navbar, Modal } from "react-bootstrap";
import { isMobileDevice } from "../Utils/index";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index.js";
import "./index.css";
  
 
const HeaderNavbar = () => {
  const [navbar, setNavbar] = useState(false);
  const domain = process.env.REACT_APP_DOMAIN || "swmc";
   
  const logoConfig = {
    swmc: {
      src: "https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-White.webp",
      href: "https://www.swmc.com/",
      alt: "SWMC"
    },
    celligence: {
      src: "https://d2w24n4g34usfg.cloudfront.net/Celligence-New/celligence-logo.webp",
      href: "https://www.celligence.com/",
      alt: "Celligence LLC"
    }
  };
  
  const currentLogo = logoConfig[domain];
   
  const isMobileOrTabletDevice = isMobileDevice();
  let prevScrollPos = window.scrollY;
  
 
  
  window.onscroll = function () {
    const currentScrollPos = window.scrollY;
    const menuNavbar = document.getElementById("menuNavbar");
    if (currentScrollPos === 0) {
      menuNavbar.classList.remove("navbarTransition");
      setNavbar(false);
    } else {
      if (prevScrollPos > currentScrollPos) {
        setNavbar(true);
      } else if (prevScrollPos < currentScrollPos) {
        if (!isMobileOrTabletDevice) {
          setNavbar(true);
        } else {
          setNavbar(false);
          menuNavbar.classList.add("navbarTransition");
        }
      }
    }
    prevScrollPos = currentScrollPos;
  };
  
  return (
    <>
      <div>
        <Navbar
          id="menuNavbar"
          collapseOnSelect
          expand="lg"
          fixed="top"
          bg="dark"
          variant="dark"
          className={navbar ? "navbar active" : "navbar"}
        >
          <Container>
            <div className="navcont">
              <Navbar.Brand className="ps-3">
                <div className="nav-logo">
                  <a
                    href={currentLogo.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={currentLogo.title}
                  >
                    <img
                      src={currentLogo.src}
                      className="main_logo"
                      alt={currentLogo.alt}
                    />
                  </a>
                </div>
              </Navbar.Brand>
              
              <div className="nav-right-section">
                 
                <div className=" ">
                  <UserWayAccessibilityMenu
                    color="white"
                    width={40}
                    height={40}
                  />
                </div>
              </div>
            </div>
          </Container>
        </Navbar>
 
      </div>
    </>
  );
};
export default HeaderNavbar;